<template>
  <div class="cp-login-view">
    <div class="cp-login-view-section">
      <p class="title is-4">Madamranee Backoffice</p>
      <b-field label="Username">
        <b-input v-model="username"></b-input>
      </b-field>

      <b-field label="Password">
        <b-input v-model="password" type="password" password-reveal> </b-input>
      </b-field>

      <br />

      <b-button
        class="cp-login-view-button"
        :loading="loading"
        rounded
        type="is-primary"
        @click="login"
        >Login</b-button
      >
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';
import { login } from '@/apis/user';

export default {
  name: 'LoginView',
  data() {
    return {
      loading: false,
      username: '',
      password: '',
    };
  },
  methods: {
    async login() {
      this.loading = true;

      try {
        await login(this.username, this.password);

        this.$router.replace({
          name: 'AdminView',
        });
      } catch (error) {
        const msg = get(error, 'response.data.error.message');

        this.$buefy.snackbar.open({
          message: msg,
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-login-view {
  &-section {
    width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 300px;
  }

  &-button {
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 150px;
  }
}
</style>
